import moment from "moment";

const ANY_SHIPPING_METHOD = "Any shipping method";
const REST_OF_WORLD = "Rest of world";

export const dayInWeekCode = [
  {
    code: 2,
    label: "Mon",
    labelFull: "Monday",
    momentCode: 1,
  },
  {
    code: 3,
    label: "Tue",
    labelFull: "Tuesday",
    momentCode: 2,
  },
  {
    code: 4,
    label: "Wed",
    labelFull: "Wednesday",
    momentCode: 3,
  },
  {
    code: 5,
    label: "Thu",
    labelFull: "Thursday",
    momentCode: 4,
  },
  {
    code: 6,
    label: "Fri",
    labelFull: "Friday",
    momentCode: 5,
  },
  {
    code: 7,
    label: "Sat",
    labelFull: "Saturday",
    momentCode: 6,
  },
  {
    code: 8,
    label: "Sun",
    labelFull: "Sunday",
    momentCode: 0,
  },
];

Date.prototype.addDays = function (days) {
  let date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

/**
 * transit_times: chứa tất cả các rules
 * Shipping country: country code của buyer,
 * courier:
 * => tìm zone chứa country code
 **/
export const getTransitTime = ({
  transit_times,
  shipping_country,
  courier,
}) => {
  const foundElement = transit_times.find((element) =>
    element.shipping_destination_country.includes(shipping_country)
  );

  const restOfWorldElement = transit_times.find((element) =>
    element.shipping_destination_country.includes(REST_OF_WORLD)
  );

  if (foundElement) {
    const shippingMethods = foundElement.shipping_method;

    const foundMethod = shippingMethods.find((method) =>
      method.courier.includes(courier)
    );
    if (foundMethod) return foundMethod;

    const anyShippingMethod = shippingMethods.find((method) =>
      method.courier.includes(ANY_SHIPPING_METHOD)
    );
    if (anyShippingMethod) return anyShippingMethod;

    const restOfWorldMethod = restOfWorldElement?.shipping_method.find(
      (method) => method.courier.includes(ANY_SHIPPING_METHOD)
    );
    if (restOfWorldMethod) return restOfWorldMethod;
  } else {
    const restOfWorldMethod = restOfWorldElement?.shipping_method[0];
    if (restOfWorldMethod) return restOfWorldMethod;
  }

  return null;
};

/** notWorkingDay: array */
const calNotWorkingDay = (day, notWorkingDay) => {
  let re = day;
  notWorkingDay.forEach((element) => {
    if (element == new Date(re).getDay()) {
      re = re.addDays(1);
    }
  });
  return re.toDateString();
};

/**
 * created by Chloe
 * @param {cutoff_time} string "16" - in API edd setting
 * @param {merchant_timezone} string "-3" - là time zone của store, trả về tại getAppSeting
 * @param {edd_timezone} string "+5" - là time zone setting trong edd in app, trả về trong edd setting
 * @param {created_time} sring - là thời điểm tạo order trên shopify
 * @param {transit_times} array - chứa tất cả các rule setting phía edd in app
 * @param {shipping_country} string - country code của diểm đến order
 * @param {courier} string - tracking_company của order
 * @param {processing_time} string "2" - số ngày chuẩn bị order, lấy từ API edd
 * @param {business_days} array - các ngày làm việc trong tuần 2 3 4 5 6 7 8
 *
 */

export const calculatorEdd = ({
  cutoff_time,
  merchant_timezone,
  edd_timezone,
  created_time,
  transit_times,
  shipping_country,
  courier,
  processing_time,
  business_days,
}) => {
  try {
    // const createdTime = new Date(created_time).addDays(4, created_time);
    /**  get UTC time in msec*/
    const utc = new Date(created_time).getTime();

    let createdTime = new Date(utc + 3600000 * Number(merchant_timezone));
    if (Number(merchant_timezone) != Number(edd_timezone)) {
      // create new Date object for different timezone
      createdTime = new Date(utc + 3600000 * Number(edd_timezone));
    }

    const cutoffDate = new Date(
      `${moment(created_time).format("YYYY-MM-DD")} ${cutoff_time}:00:00`
    );

    const cutoffDay = createdTime > cutoffDate ? 1 : 0;

    /**lấy ra đúng transit time của zone*/
    const dateRangeTransit = getTransitTime({
      transit_times,
      shipping_country,
      courier,
    });

    // tính toán khoảng thời gian cutoff, processing time và 2 ngày trong date range transit time
    const firstRange =
      cutoffDay +
      Number((dateRangeTransit && dateRangeTransit?.first) || 0) +
      Number(processing_time);

    const secondRange =
      cutoffDay +
      Number((dateRangeTransit && dateRangeTransit?.second) || 0) +
      Number(processing_time);

    const firstDateAfterCal = new Date(createdTime).addDays(firstRange);

    const secondDateAfterCal = new Date(createdTime).addDays(secondRange);

    const notWorkingDay = dayInWeekCode.filter(
      (day) => !business_days.includes(day.code)
    );

    const notWorkingDayMomentCode = notWorkingDay.map((day) => day.momentCode);

    const dayFirst = calNotWorkingDay(
      firstDateAfterCal,
      notWorkingDayMomentCode
    );

    const daySecond = calNotWorkingDay(
      secondDateAfterCal,
      notWorkingDayMomentCode
    );

    // console.log({
    //   merchant_timezone,
    //   edd_timezone,
    //   created_time,
    //   createdTime,
    //   cutoffDate,
    //   cutoffDay,
    //   processing_time,
    //   firstRange,
    //   secondRange,
    //   dateRangeTransit,
    //   firstDateAfterCal,
    //   secondDateAfterCal,
    //   notWorkingDay,
    //   notWorkingDayMomentCode,
    //   dayFirst,
    //   daySecond,
    // });

    if (dayFirst === daySecond) {
      return [dayFirst];
    } else return [dayFirst, daySecond];
  } catch (error) {
    console.error("An exception occurred:", error);
    return [];
  }
};
